

























































import Vue from "vue";
import { Header } from "@/components/MyTable.vue";
import { ListHeader } from "@/components/MyListCard.vue";
import { axios } from "../../../plugins";

const AlarmRulesHeader: Header[] = [
  { title: "序号", key: "", width: 80 },
  { title: "状态", key: "", width: 110 },
  { title: "消息", key: "", width: 200 },
  { title: "最近状态检查时间", key: "", width: 180 },
  { title: "最近状态更新时间", key: "", width: 180 }
];
const ScheduledTaskHeaders: Header[] = [
  { title: "任务名称", key: "", width: 180 },
  { title: "状态", key: "", width: 110 },
  { title: "开始时间", key: "", width: 180 },
  { title: "结束时间", key: "", width: 180 }
];
const infoHeader: ListHeader[] = [
  { title: "任务名称", key: "name" },
  { title: "任务描述", key: "description" },
  { title: "最大重试次数", key: "backoffLimit" },
  { title: "完成数", key: "completions" },
  { title: "并行数", key: "parallelism" },
  { title: "退出超时时限(秒)", key: "activeDeadlineSeconds" }
];
export default Vue.extend({
  name: "Overview",
  props: {
    data: { type: Object },
    kind: { type: String },
    projectId: { type: String }
  },
  data() {
    return {
      AlarmRulesHeader,
      ScheduledTaskHeaders,
      infoHeader,
      tableData: []
    };
  },
  mounted() {
    this.getHistory();
  },
  methods: {
    searchAction(val: any) {
      console.log("val:" + val);
    },
    getHistory() {
      if (this.kind === "ScheduledTask") {
        axios
          .get(`/cronJobs/${this.projectId}/cronJob/${this.data.name}/history `)
          .then(res => {
            this.tableData = res.data.data;
          });
      }
    },
    showTaskInfo(data: any) {
      this.$emit("showTask", data);
    },
    getStatus(data: any) {
      let _status = "Running";

      if (!data.status) {
        return "Failed";
      }
      if (data.status.conditions) {
        (data.status.conditions as any[]).some(item => {
          if (item.type === "Failed" && item.status === "True") {
            _status = "Failed";
            return true;
          }

          if (item.type === "Complete" && item.status === "True") {
            _status = "Completed";
            return true;
          }

          return false;
        });
        return _status;
      }
      if (data.spec.Completions <= data.status.Succeed) _status = "Failed";

      return _status;
    }
  }
});
